export default import.meta.ROLLDOWN_FILE_URL_tBCVIqzn3p1lJ4T4Xm84Vw